module.exports = __webpack_public_path__ + "static/media/combo_2.bb1c7d66.png";